import { Injectable } from "@angular/core";

import { CustomRequestService } from "../custom-request/custom-request.service";
import { LzUserServiceV2 } from "../../modules/lz-user/services/lz-user.serivce.v2";
import { LzProductConfig } from "../../services/product-config/poduct-config";

@Injectable()
export class LzSettingsService {

  private userSettings: any = {};

  constructor(private customRequestService: CustomRequestService,
    private user: LzUserServiceV2,
    private config: LzProductConfig) {}

  /**
   * set settings on server
   * @param variable - is a name of setting
   * @param value - object with data
   * @param callback
   */
  public setSettings = (variable: any, value: any, callback ? : any) => {
    this.user.getUserInfo(msg => {
      if (msg.anonymous == false) {
        this.customRequestService.postRequestWithFormData(
          this.config.getApiLink() + '/lz-platforma/user-settings/v1.0/setValue', {
            variable: variable,
            value: JSON.stringify(value)
          },
          undefined, {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        ).toPromise().then(() => {
          if (callback) {
            callback();
          }
        });
      } else {
        if (callback) {
          callback();
        }
      }
    });
  }

  private getByName = (name: any, callback: any) => {
    this.user.getUserInfo(msg => {
      if (msg.anonymous == false) {
        this.customRequestService.getRequest(
          this.config.getApiLink() + '/lz-platforma/user-settings/v1.0/getAll',
        ).toPromise().then(msg => {
          if (msg) {
            for (let name in msg) {
              this.userSettings[name] = JSON.parse(msg[name]);
            }
            if (this.userSettings[name]) {
              callback(this.userSettings[name]);
            } else {
              callback('');
            }
          } else {
            callback('');
          }
        });
      } else {
        callback('');
      }
    });
  }

  /**
   * set settings on server
   * @param name - is a name of setting
   * @param callback
   * @param isFromServer - is need settings from server or we can take it from local variable if it exist
   */
  public getSettingsByName = (name: any, callback: any, isFromServer ? : boolean) => {
    if (isFromServer) {
      this.getByName(name, callback);
    } else {
      if (this.userSettings && this.userSettings[name]) {
        callback(this.userSettings[name]);
      } else {
        this.getByName(name, callback);
      }
    }
  }

  /**
   * return settings promise
   */
  getSettingsSimple = () => {
    return this.customRequestService.getRequest(
      this.config.getApiLink() + '/lz-platforma/user-settings/v1.0/getAll',
    );
  }

  /**
   * reset settings to default;
   */
  public setDefault = () => {
    this.customRequestService.getRequest(
      this.config.getApiLink() + '/lz-platforma/user-settings/v1.0/deleteAll',
    ).toPromise().then(msg => {
      window.localStorage.setItem('lang', 'ua');
      window.location.reload();
    });
  }

  /**
   * set lang
   * @param newLang
   * @param callback
   */
  saveLang = (newLang: string, callback ? : any) => {
    this.setSettings('language', {
      lang: newLang
    }, callback);
  }

  /**
   * return lang through callback
   * @param callback
   */
  public getLang = callback => {
    this.getSettingsByName('language', callback);
  }

}
